export default "__VITE_ASSET__CBkCrgDR__";